var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 29,
    viewBox: "0 0 6 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 22.5556C3.79565 22.5556 4.55871 22.895 5.12132 23.4993C5.68393 24.1036 6 24.9232 6 25.7778C6 26.6324 5.68393 27.4519 5.12132 28.0562C4.55871 28.6605 3.79565 29 3 29C2.20435 29 1.44129 28.6605 0.87868 28.0562C0.316071 27.4519 0 26.6324 0 25.7778C0 24.9232 0.316071 24.1036 0.87868 23.4993C1.44129 22.895 2.20435 22.5556 3 22.5556ZM3 11.2778C3.79565 11.2778 4.55871 11.6173 5.12132 12.2215C5.68393 12.8258 6 13.6454 6 14.5C6 15.3546 5.68393 16.1742 5.12132 16.7785C4.55871 17.3827 3.79565 17.7222 3 17.7222C2.20435 17.7222 1.44129 17.3827 0.87868 16.7785C0.316071 16.1742 0 15.3546 0 14.5C0 13.6454 0.316071 12.8258 0.87868 12.2215C1.44129 11.6173 2.20435 11.2778 3 11.2778ZM3 0C3.79565 0 4.55871 0.339483 5.12132 0.943768C5.68393 1.54805 6 2.36764 6 3.22222C6 4.07681 5.68393 4.89639 5.12132 5.50068C4.55871 6.10496 3.79565 6.44444 3 6.44444C2.20435 6.44444 1.44129 6.10496 0.87868 5.50068C0.316071 4.89639 0 4.07681 0 3.22222C0 2.36764 0.316071 1.54805 0.87868 0.943768C1.44129 0.339483 2.20435 0 3 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedot);
export default __webpack_public_path__ + "static/media/three dot.b242e66ee884d163de0a953e298570c6.svg";
export { ForwardRef as ReactComponent };